module.exports = __webpack_public_path__ + "images/emoji/ambulance.1b00aeadfa47c15210aa.png";